import { CookieTool } from "./cookieTool";
import axios from "axios";
import { CookieEnum, EnvironmentEnum, StorageEnum } from "../enum";
import { AppTool } from "./appTool";
import { UrlConfig } from "../config/urlConfig";
import { AppData } from "../data";
import { RoleEnum } from "./../enum/roleEnum";

export const defaultToken =
  "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI1WkpaUl9rYVZPX2lPNlU5eWEzOFZnMkVwREpZWEhqdC1Fb1k4WjRQX2xNIn0.eyJqdGkiOiIxZDRmNmJlMC1iYzk2LTQ3ZTQtODljMy02NGFhYzIyYjNjNTIiLCJleHAiOjE2OTMwMjEyMzYsIm5iZiI6MCwiaWF0IjoxNjkyMTU3MjM2LCJpc3MiOiJodHRwczovL2FjY291bnRzLWRldi5tYXA0ZC52bi9hdXRoL3JlYWxtcy9tYXA0ZC1kZXYiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiYzNiYjg3YjAtZjE0Yy00NGE5LWE4NGMtNTc3NWYyMWUyOGQ2IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibWFwNGQtZGV2IiwiYXV0aF90aW1lIjoxNjkyMTU3MjM2LCJzZXNzaW9uX3N0YXRlIjoiYjhmOTA5YTgtMTFiMS00ZjM5LTk4NzAtZGYxYjc3YmRkN2YwIiwiYWNyIjoiMSIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwczovL3Rlc3QubWFwNGQudm4iLCJodHRwOi8vbG9jYWxob3N0OjUzNDUwIiwiaHR0cDovL2xvY2FsaG9zdDozMDAwIiwiaHR0cHM6Ly9kZXYubWFwNGQudm4iXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIm9mZmxpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iXX0sInJlc291cmNlX2FjY2VzcyI6eyJhY2NvdW50Ijp7InJvbGVzIjpbIm1hbmFnZS1hY2NvdW50IiwibWFuYWdlLWFjY291bnQtbGlua3MiLCJ2aWV3LXByb2ZpbGUiXX19LCJzY29wZSI6ImVtYWlsIHByb2ZpbGUiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGhvbmUiOiI4NDM1NjEwMzc4MiIsIm5hbWUiOiJEZXYgUHJvIE1heCBMw6oiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJkZXZAZ21haWwuY29tIiwibG9jYWxlIjoidmkiLCJnaXZlbl9uYW1lIjoiRGV2IFBybyBNYXgiLCJmYW1pbHlfbmFtZSI6IkzDqiIsImVtYWlsIjoiZGV2QGdtYWlsLmNvbSJ9.DRnaCux6KorGBGa1IEJ1ocoD2GR7O6DGRWj-GPYjevl1ozY5Zl_1hfxtjBX5NiZz6sR_0VPWHD7kH6D3E-gioHNYbSXxDMvWqi5SJ4_S-KGxEUOyx-yRJ6SMksK2u1n2YudZI0bWXzd2wZoV7OwKnqvqhjMETSx5w-n1Z6pLXgYLW0h0zuaLGn59LEh0rBdBZW-aiAeMQHP6iJmZAHq0eFZ6c5-bSl5jN-eK4eV8J_bG5Dp1tktHGP9xJsYk75w0p0U0aSZitsMwhuklXw14pt9kwUe4rVLopWXSMrmCle1coHAElvqUqPvXFSr9rYF4IWqBLXPSshH0k85zAWDUZw";

export class UserTool {
  static getToken = (callback) => {
    if (AppTool.isLocal()) {
      callback(defaultToken);
      return;
    }
    let source = axios.CancelToken.source();
    let token = CookieTool.get(CookieEnum.token);
    if (token) {
      callback(token);
    } else {
      let returnUrl = encodeURI(location.href);
      location.href = UrlConfig.auth.login + "?returnUrl=" + returnUrl;
      callback(null);
    }
    return source;
  };

  static getUser = () => {
    let user = AppData.user;
    return user;
  };

  static isOneOfRoles = (roleCodes) => {
    return roleCodes.some((code) =>
      UserTool.getUser()?.roles?.some((role) => role.code == code)
    );
  };

  static isAdmin = () => {
    return AppData.user?.roles?.some((role) => role?.code == RoleEnum.admin);
  };

  static isPermission = (permission) => {
    let check = AppData?.user?.roles?.some((role) => {
      return role?.permissionGroups?.includes(permission);
    });
    return check || UserTool.isAdmin();
  };
  static hasPermission = () => {
    let pers = [];
    AppData?.user?.roles?.forEach((role) => {
      pers = pers.concat(role.permissionGroups || []);
    });
    return pers?.length >= 1 || UserTool.isAdmin();
  };
}
